import {
  Component,
  Input,
  EventEmitter,
  Output,
  HostListener,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";

@Component({
  selector: "app-planselect-dropdown-checkbox",
  templateUrl: "./planselect-dropdown-checkbox.component.html",
  styleUrls: ["./planselect-dropdown-checkbox.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PlanselectDropdownCheckboxComponent {
  showDropDown = false;
  objKeyList;
  planPageKey;
  totalcheckedAmount: number = 0;
  reset: boolean;
  allPlansUnchecked = false;
  totalSelectedPlans;

  private _childObj;

  @Input() set childObj(value: any) {
    this._childObj = value;
    if (value) {
      this.updateCounts();
    }
  }
  get childObj() {
    return this._childObj;
  }

  @Input() parentWidth;
  @Input() set childReset(v: boolean) {
    this.reset = v;
    this.updateCounts();
  }
  @Input() set selectedPlans(value: object) {
    this.totalSelectedPlans = value;
    this.cdr.markForCheck();
  }
  @Output() passSelect = new EventEmitter();
  @Output() passAllPlanUnchecked = new EventEmitter<boolean>();

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target) && this.showDropDown) {
      this.showDropDown = true;
    } else {
      this.showDropDown = false;
    }
  }
  constructor(private eRef: ElementRef, private cdr: ChangeDetectorRef) {}

  updateCounts() {
    if (!this._childObj) {
      return;
    }
    const keyList = Object.keys(this._childObj);
    if (keyList.includes("HMO") || keyList.includes("Gold")) {
      this.planPageKey = keyList;
    } else {
      this.objKeyList = keyList;
    }
    this.totalcheckedAmount = keyList.filter(
      (key) => this._childObj[key] === true
    ).length;
    this.allPlansUnchecked = this.totalcheckedAmount === 0;
    this.cdr.markForCheck();
  }

  childSelect(item: string) {
    this._childObj[item] = !this._childObj[item];
    if (this._childObj[item] === false) {
      this.totalcheckedAmount--;
    } else {
      this.totalcheckedAmount++;
    }
    if (this.totalcheckedAmount === 0) {
      this.allPlansUnchecked = true;
      this.passAllPlanUnchecked.emit(this.allPlansUnchecked);
    }
    this.passSelect.emit({ ...this._childObj });
    this.cdr.markForCheck();
  }
}
